<script setup lang="ts">
defineProps({
  srcUrl: {
    type: String,
    required: true,
  },
  poster: {
    type: String,
    required: false,
    default: undefined,
  },
});
const backgroundVideo = ref<HTMLVideoElement>();
let itemObserver: IntersectionObserver | null = null;

const orientation = ref();

onMounted(() => {
  const {getOrientation} = useUtils();
  orientation.value = getOrientation();

  document.addEventListener('visibilitychange', onVisibilityChange);

  itemObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (backgroundVideo.value) {
        if (entry.isIntersecting) {
          backgroundVideo.value!.play();
        } else {
          backgroundVideo.value!.pause();
        }
      }
    });
  });

  itemObserver.observe(backgroundVideo.value!);
});

function onVisibilityChange() {
  if (document.visibilityState === 'visible') {
    backgroundVideo.value!.play();
  } else {
    backgroundVideo.value!.pause();
  }
}

onBeforeUnmount(() => {
  if (itemObserver) itemObserver.unobserve(backgroundVideo.value!);
  document.removeEventListener('visibilitychange', onVisibilityChange);
});
</script>

<template>
  <div class="background-video h-screen w-screen max-w-[2560px] relative overflow-hidden">
    <video ref="backgroundVideo" class="w-full h-full absolute t-0 l-0 object-cover object-center" :class="{portrait: orientation === 'portrait'}" autoplay muted loop playsinline :poster="poster || ''">
      <source :src="`${srcUrl}.webm`" type="video/webm" />
      <source :src="`${srcUrl}.mp4`" type="video/mp4" />
    </video>
  </div>
</template>

<style lang="scss" scoped>
.background-video {
  max-height: 100vh;

  @media only screen and (device-width: 1024px) and (device-height: 1366px) {
    height: 100vh;
    max-height: 100vh;
  }
}
</style>
